module.exports = __webpack_public_path__ + "img/ic_chat_bubble.12fa09e8.svg";